import React from 'react';
import {Link} from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
    return (
        <>
            <footer>
                <div className="footer max-w-full mx-auto px-4 sm:px-6 bg-red-100 border-t border-b py-30">

                    {/* Top area: Blocks */}
                    <div className="grid sm:grid-cols-12 gap-5 py-8 md:py-12 border-t border-gray-200 lg:ml-11">

                    {/* 1st block */}
                    <div className="col-span-12 lg:col-span-4">
                        <div className="box-border border-b-4 border-red-900 p-8 bg-gray-200 text-gray-600 text-center rounded-lg xl:w-80 mx-auto">
                            <h3 className="font-bold text-4xl text-red-800 mb-4">KIM MAID</h3>
                            <div className='text-md font-medium font-bold text-2xl  text-gray-800'>
                              <p>Virginia</p>
                                <p>DC</p>
                                <p>Maryland</p>
                            </div>
                        </div>
                    </div>

                    {/* 2nd block */}
                    <div className="col-span-6 md:col-span-6 lg:col-span-1 ml-7 mx-auto">
                        <h6 className="text-[#013289] text-xl text-red-900 font-bold mb-4">LINKS</h6>
                        <ul className="text-md">
                        <li className="mb-2">
                            <HashLink to="#about" className="text-[#013289] text-red-800 hover:text-red-900 hover:tracking-wider transition duration-250 ease-in-out">About</HashLink>
                        </li>
                        <li className="mb-2">
                            <HashLink to="#services" className="text-[#013289] text-red-800 hover:text-red-900 hover:tracking-wider transition duration-250 ease-in-out">Services</HashLink>
                        </li>
                        <li className="mb-2">
                            <HashLink to="#" className="text-[#013289] text-red-800 hover:text-red-900 hover:tracking-wider transition duration-250 ease-in-out">Pricing</HashLink>
                        </li>  
                        <li className="mb-2">
                            <HashLink to="#" className="text-[#013289] text-red-800 hover:text-red-900 hover:tracking-wider transition duration-250 ease-in-out">Contact</HashLink>
                        </li>                            
                        </ul>
                    </div>

                    {/* 3rd block */}
                    <div className="col-span-6 md:col-span-6 lg:col-span-4 mx-auto">
                        <h6 className="text-[#013289] text-xl text-red-900 font-bold mb-4">OUR SERVICES</h6>
                        <ul className="text-md">
                        <li className="mb-2">
                            <Link to="#" className="text-[#013289] text-red-800 hover:text-red-900 hover:tracking-wider transition duration-250 ease-in-out">Move In / Out</Link>
                        </li>
                        <li className="mb-2">
                            <Link to="#" className="text-[#013289] text-red-800 hover:text-red-900 hover:tracking-wider transition duration-250 ease-in-out">Homes / Apartments</Link>
                        </li>
                        <li className="mb-2">
                            <Link to="#" className="text-[#013289] text-red-800 hover:text-red-900 hover:tracking-wider transition duration-250 ease-in-out">AirBnb</Link>
                        </li>
                        <li className="mb-2">
                            <Link to="#" className="text-[#013289] text-red-800 hover:text-red-900 hover:tracking-wider transition duration-250 ease-in-out">Offices</Link>
                        </li>
                        </ul>
                    </div>

                    {/* 4th block */}
                    <div className="col-span-12 text-center mx-auto lg:col-span-3 font-bold uppercase text-blue-900">
                        <div className="text-xl mb-6 text-red-900 ">
                            Social Media Links.
                        </div>

                                <div className="text-md font-medium mb-6 text-red-900 ">
                                    Follow us on social media.
                                </div>
                        <div className="mx-auto text-center mt-2">
                                <ul className="flex justify-center mb-4 md:mb-0">
  <a 
    href="https://www.instagram.com/kimmaids_/" 
    className="flex justify-center items-center text-blue-900 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out" 
    aria-label="Instagram" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path d="M34.5 0H13.5C6.1 0 0 6.1 0 13.5v21C0 41.9 6.1 48 13.5 48h21c7.4 0 13.5-6.1 13.5-13.5v-21c0-7.4-6.1-13.5-13.5-13.5zM24 17.8c3.5 0 6.3 2.8 6.3 6.3 0 3.5-2.8 6.3-6.3 6.3-3.5 0-6.3-2.8-6.3-6.3 0-3.5 2.8-6.3 6.3-6.3zm7.8 9.3c0 2.5-2.1 4.6-4.6 4.6-2.5 0-4.6-2.1-4.6-4.6 0-2.5 2.1-4.6 4.6-4.6 2.5 0 4.6 2.1 4.6 4.6zm-7.8-5.6c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10 0-5.5-4.5-10-10-10zM24 5.7c5.7 0 10.3 4.6 10.3 10.3 0 .6-.5 1-1 1s-1-.5-1-1c0-4.7-3.8-8.5-8.5-8.5-4.7 0-8.5 3.8-8.5 8.5 0 .6-.5 1-1 1s-1-.5-1-1c0-5.7 4.6-10.3 10.3-10.3zM13.5 4h21c1.7 0 3.1 1.4 3.1 3.1v21c0 1.7-1.4 3.1-3.1 3.1H13.5c-1.7 0-3.1-1.4-3.1-3.1v-21c0-1.7 1.4-3.1 3.1-3.1z"/>
    </svg>
  </a>
                                    <li className="ml-4">
                                          <a 
    href="https://www.facebook.com/profile.php?id=61580010342883" 
    className="flex justify-center items-center text-blue-900 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out" 
    aria-label="facebook" 
    target="_blank" 
    rel="noopener noreferrer"
  >
                                        <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.023 24L14 17h-3v-3h3v-2c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V14H21l-1 3h-2.72v7h-3.257z" />
                                        </svg>

  </a>

                                    </li>
                                </ul>
                            </div>
                    </div>          

                    </div>

                    <div className="flex flex-wrap items-center md:justify-between justify-center mx-auto px-4">
                <div className="w-full md:w-4/12 px-4 mx-auto text-center py-2">
                    <div className="text-sm text-gray-200 font-semibold py-1">
                    Copyright &copy; {new Date().getFullYear()}{"  "}
                    <HashLink
                        to="#"
                        className=" hover:text-gray-900"
                    >
                       
                    </HashLink>. All rights reserved.
                    </div>
                </div>
                </div>

                </div>
                
            </footer>
        </>
    )
}
export default Footer;
